import { useState } from 'react';
import Board from './Board'
import checkWinner from './CheckWinner'

const Game = () => {
    const [history, setHistory] = useState([Array(9).fill(null)])

    const [stepNumber, setStepNumber] = useState(0);
    const [nextX, setNextX] = useState(true)
    const winner = checkWinner(history[stepNumber])
    const xO = nextX ? "X" : "O"

    const handleClick = (i) => {
        const historyPoint = history.slice(0, stepNumber + 1);
        const current = historyPoint[stepNumber];
        const squares = [...current];
        // return if won or occupied

        if (winner || squares[i]) return;

        squares[i] = xO;
        setHistory([...historyPoint, squares]);
        setStepNumber(historyPoint.length)
        setNextX(!nextX)
    }

    const jumpTo = (step) => {
        setStepNumber(step)
        setNextX(step % 2 === 0);
    }

    const renderMoves = () =>
        history.map((_step, move) => {
            const destination = move ? `Move Number #${move}` : "Reset The Game"

            return (
                <li key={move}>
                    <button onClick={() => jumpTo(move)}>
                        {destination}
                    </button>
                </li>
            )
        })

    return (
        <>
            <h1>Tic Tac Toe</h1>
            <div className="main">
                <div className="info-wrapper">
                    <div>
                        <h3>Moves</h3>
                        {renderMoves()}
                    </div>
                </div>


                <Board squares={history[stepNumber]} onCLick={handleClick} />

                <div className="info-wrapper">

                    <h3>{winner ? winner : "Next Player: " + xO}</h3>
                    {/* <div>
                        <h3>History</h3>
                        {renderMoves()}
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default Game;